<template>
  <base-modal modal-id="verify-email" content-class="edit-profile">
    <template v-slot:header>
      <button type="button" class="btn btn-arrow" @click="proceedBack">
        <img src="/images/svg/global/left_arrow.svg" alt="" />
      </button>
      <h4 class="modal-title mb-0 d-sm-block d-none">
        {{ _T('Input Verification Code') }}
      </h4>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Verification Code') }}</h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form verification-code">
        <div class="form-group">
          <label>
            <span>{{
              _T('A verification code has been sent to the email')
            }}</span>
            {{ _T('(B***********@*****.com)') }}
          </label>
          <div class="digit-group">
            <input
              type="text"
              id="digit-1"
              name="digit-1"
              data-next="digit-2"
              :class="{ fill: true }"
            />
            <input
              type="text"
              id="digit-2"
              name="digit-2"
              data-next="digit-3"
              data-previous="digit-1"
              :class="{ fill: true }"
            />
            <input
              type="text"
              id="digit-3"
              name="digit-3"
              data-next="digit-4"
              data-previous="digit-2"
              :class="{ fill: true }"
            />
            <input
              type="text"
              id="digit-4"
              name="digit-4"
              data-next="digit-5"
              data-previous="digit-3"
              :class="{ fill: true }"
            />
            <input
              type="text"
              id="digit-5"
              name="digit-5"
              data-next="digit-6"
              data-previous="digit-4"
              :class="{ fill: true }"
            />
            <input
              type="text"
              id="digit-6"
              name="digit-6"
              data-previous="digit-5"
              :class="{ fill: true }"
            />
          </div>
        </div>
        <button
          type="button"
          class="btn btn-danger btn-block"
          @click="proceedFurther"
        >
          {{ _T('Verfiy') }}
        </button>
        <h6>
          {{ _T('Tidak menerima Kode?') }}
          <span class="font-primary">{{ _T('Kirim Ulang') }}</span>
          {{ _T('( 00 : 03 )') }}
        </h6>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'VerifyEmail',
  components: {
    BaseModal,
  },
  methods: {
    proceedBack() {
      this.$bvModal.hide('verify-email')
      this.$bvModal.show('change-email')
    },
    proceedFurther() {
      this.$bvModal.hide('verify-email')
      this.$bvModal.show('check-email-modal')
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss">
// @import '@/scss/theme/_variables.scss';
.digit-group {
  direction: ltr;
  display: flex;
  input {
    display: inline-block;
    width: 100%;
    border: $px2 solid $light-border;
    transition: 0.3s ease;
    text-align: center;
    &:focus {
      outline: none;
    }
    &.fill {
      border: $px2 solid rgb(173, 31, 52);
      transition: 0.3s ease;
    }
    + input {
      margin-left: $px10;
    }
  }
}
</style>
